import { useNavigate } from "react-router-dom";

import { Button, Span, Tag } from "@icg360/design-system";

import type { NotificationDetail } from "components/notifications/hooks";
import styles from "components/notifications/notifications-drawer/notification-item.module.scss";
import { usePolicyDetail } from "data/ss-data-hooks";
import { capitalizeEachWord } from "utils";

type NotificationItemProps = {
  notifications: NotificationDetail[];
  onClose: () => void;
};

export const NotificationItem = ({
  notifications,
  onClose,
}: NotificationItemProps) => {
  const navigate = useNavigate();
  const { data: policy } = usePolicyDetail();

  return (
    <div className={styles.notificationsGroup}>
      {notifications.map((notification) => {
        const notificationTitle = notification.offerTitle ?? "";
        const notificationDescription = notification.offerDescription;
        const notificationSubheaderMessage =
          notification.buttonText != undefined
            ? `${notification.buttonText}`
            : `Get started`;
        const isUnread = !notification.read;
        return (
          <div
            key={notification.offerInternalName}
            className={
              isUnread
                ? styles.unreadNotificationHolder
                : styles.notificationHolder
            }
          >
            <div className={styles.notificationContent}>
              <div className={styles.addressHolder}>
                <Tag icon="House" size="medium">
                  {capitalizeEachWord(
                    policy?.userDetails?.propertyAddress?.street1 ?? "",
                  )}{" "}
                </Tag>
              </div>
              <Span size="md" className={styles.notificationTitle}>
                {notificationTitle}
              </Span>
              <Span size="sm" className={styles.notificationDescription}>
                {notificationDescription}
              </Span>
            </div>
            <div className={styles.notificationActions}>
              <Button
                className={styles.dismissButton}
                appearance="secondary"
                size="md"
                aria-label={`Dismiss ${notificationTitle}`}
              >
                Dismiss
              </Button>

              <Button
                appearance="primary"
                size="md"
                aria-label={`Click to learn more about ${notificationTitle}`}
                onPress={() => {
                  onClose();
                  if (notification.path) {
                    navigate(notification.path);
                  }
                }}
              >
                {notificationSubheaderMessage}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
